import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    alignSelf: "center",
    paddingHorizontal: 6,
    width: 350,
    height: 380,
    borderWidth: 0.5,
    borderRadius: 8,
    borderColor: "#FFF",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  action_button: {
    marginTop: 30,
    width: 320,
    alignSelf: "center",
    padding: 10,
    borderRadius: 4,
    backgroundColor: "#077A97",
    color: "#fff",
  },
  disabled_button: {
    backgroundColor: "#b0b0b0", // Cor para o botão desabilitado
  },
  action_button_text: {
    color: "#fff",
    justifyContent: "center",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
    textTransform: "uppercase",
  },
  view: {
    marginTop: 20,
    alignItems: "center",
  },
  nameCategory: {
    position: "absolute",
    marginTop: 110,
    textAlign: "center",
    color: "#fff",
    fontWeight: "bold",
    width: "100%",
  },
  contentDescription: {
    padding: 15,
    marginTop: 20,
  },
  description: {
    textAlign: "justify",
    fontSize: 12,
    fontWeight: "400",
    lineHeight: 16,
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 14,
    fontWeight: "500",
  },
  label: {
    fontWeight: "600",
    fontSize: 14,
    marginBottom: 10,
    marginTop: 20,
  },
  input: {
    paddingLeft: 4,
    width: 320,
    borderWidth: 0.5,
    borderRadius: 4,
    borderColor: "#FFF",
    lineHeight: 35,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
});

export default styles;
